import { getFirehoseNewsFeed } from ".";
import { NewsFeedItem } from "./models";
import { ingestFirehoseStory } from "./ingestFirehoseStory";

/**
 * Polling fallback for the firehose stream. Fetches the cached `/news`
 * endpoint (latest 50 stories) and routes each item through the same
 * ingestion path the live SSE handler uses. Sound notifications are
 * suppressed so a backfill batch doesn't spam the user once SSE recovers.
 *
 * Iterates oldest→newest so the store's prepend-on-add behaviour preserves
 * descending-id ordering. Idempotent: ingestFirehoseStory dedupes by id.
 */
export async function pollFirehoseAndIngest(): Promise<void> {
  const stories = (await getFirehoseNewsFeed()) as NewsFeedItem[];
  const sorted = [...stories].sort((a, b) => a.id - b.id);
  for (const story of sorted) {
    ingestFirehoseStory(story, { skipSound: true });
  }
}
